module.exports = __webpack_public_path__ + "static/media/blog-post.f0028e38.jpg";